import Cookies from 'js-cookie'

const cookieName = 'article-feedback'

// set session cookie specific to current path
export function setFeedbackCookie() {
  const currentPath = window.location.href
  const cookie = {
    path: currentPath,
  }
  const cookieValue = JSON.stringify(cookie)
  // browser automatically removes domain part of url
  document.cookie = `${cookieName}=${cookieValue};path=${currentPath}`
}

// retrieve session cookie for current path
export function getFeedbackCookie() {
  const cookie = Cookies.get(cookieName)
  const currentPath = window.location.href

  if (cookie) {
    let cookieAsJSON = JSON.parse(cookie)
    if (cookieAsJSON.path === currentPath) return cookieAsJSON

    return null
  }
}
